<div class="modal-header" mat-dialog-title>
  <div class="modal-header-icon">
    <mat-icon class="material-symbols-outlined">bookmark_added</mat-icon>
  </div>
  <div class="modal-header-titles">
    <h2 class="modal-title">Nova reserva de estoque</h2>
    <span class="modal-subtitle">
      {{ data.descricaoProduto }} · SKU: {{ data.skuProduto || '-' }}
      @if (possuiRastreabilidade) {
      <span class="status-badge badge-cinza ms-1">Controla {{ data.isControlaLotes ? 'lote' : 'série' }}</span>
      }
    </span>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn" [disabled]="isSalvando" (click)="cancelar()">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content">
  <div class="sub-section-title">
    <mat-icon>tune</mat-icon>
    <span>Dados da reserva</span>
  </div>

  <div class="form-grid">
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Local de estoque</mat-label>
      <mat-select [(ngModel)]="idLocalizacaoEstoque" (selectionChange)="onLocalChange()" required>
        @for (local of localizacoes; track local.id) {
        <mat-option [value]="local.id">{{ local.descricao }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Validade (opcional)</mat-label>
      <input matInput [matDatepicker]="picker" [(ngModel)]="dataValidadeReserva" (input)="onDateInput($event)"
        (keydown)="onDateKeydown($event)" (blur)="onDataValidadeReservaBlur($event)" placeholder="DD/MM/AAAA"
        inputmode="numeric" maxlength="10" />
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </div>

  <div class="sub-section-title">
    <mat-icon>bookmark_added</mat-icon>
    <span>Quantidade</span>
  </div>

  <div class="quantidade-row">
    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="campo-quantidade">
      <mat-label>Quantidade</mat-label>
      <input matInput type="text" inputmode="decimal" [(ngModel)]="quantidade" [currencyMask]="quantidadeMask"
        placeholder="0,00" required />
    </mat-form-field>
    @if (disponivelLocal !== null) {
    <span class="disponivel-local" [class.disponivel-local-excedido]="excedeDisponivel">
      Disponível: {{ disponivelLocal | abnt:'quantidade' }} {{ data.unidade || '' }}
    </span>
    }
  </div>

  @if (possuiRastreabilidade) {
    @if (!idLocalizacaoEstoque) {
    <div class="els-vazio">Selecione o local de estoque para informar {{ data.isControlaLotes ? 'lotes' : 'séries' }}.</div>
    } @else {
    <app-estoque-lote-serie-inline
      [tipo]="data.isControlaLotes ? 'lote' : 'serie'"
      modo="selecionar"
      [quantidadeAlvo]="quantidade"
      [isFracionada]="data.isFracionada"
      [idProduto]="data.idProduto"
      [idLocalizacaoEstoque]="idLocalizacaoEstoque"
      [itens]="itensRastreabilidade"
      (itensChange)="onItensRastreabilidadeChange($event)">
    </app-estoque-lote-serie-inline>
    }
  }

  <div class="sub-section-title">
    <mat-icon>notes</mat-icon>
    <span>Descrição / Motivo</span>
  </div>

  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
    <mat-label>Descrição</mat-label>
    <textarea matInput [(ngModel)]="descricao" rows="3"></textarea>
  </mat-form-field>

  @if (excedeDisponivel) {
  <app-alert-card type="error" class="aviso-validacao">Quantidade a reservar excede o saldo disponível.</app-alert-card>
  }
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
  <button mat-stroked-button class="btn-secondary" type="button" [disabled]="isSalvando" (click)="cancelar()">
    Cancelar
  </button>
  <button mat-flat-button class="btn-primary" type="button" [disabled]="!podeConfirmar" (click)="salvar()">
    @if (isSalvando) { <mat-spinner diameter="20"></mat-spinner> }
    @else { <span>Confirmar</span> }
  </button>
</mat-dialog-actions>
